import { useTranslation } from "@i18n";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";

type IncorrectlyPlacedItemsModalProps = {
  successCallback: () => void;
  closeModal: () => void;
};

function IncorrectlyPlacedItemsModal({ successCallback, closeModal }: IncorrectlyPlacedItemsModalProps) {
  const { t } = useTranslation();
  const header = () => <span>{t("Items incorrectly placed")}</span>;

  const content = () => <div>{t("Do you want auto place the item(s) at their correct positions?")}</div>;

  const footer = () => (
    <div className="flex gap-4">
      <ButtonComponent buttonType={BUTTON_TYPES.GRADIENT_BUTTON} onClick={successCallback}>
        {t("Confirm")}
      </ButtonComponent>
      <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeModal}>
        {t("Cancel")}
      </ButtonComponent>
    </div>
  );
  return (
    <ModalStateDialogComponent
      headerTitle={header()}
      modelContent={content()}
      footerContent={footer()}
      onCancel={closeModal}
      isVisible
      width="34.375rem"
    />
  );
}
export default IncorrectlyPlacedItemsModal;
